import { md5 } from 'hash-wasm'

export const calculateChecksum = async (file: File): Promise<string> => {
  const fileArrayBuffer = await file.arrayBuffer()
  const hash = await md5(new Uint8Array(fileArrayBuffer))
  const hashBytes = new Uint8Array(hash.length / 2)
  for (let i = 0; i < hash.length; i += 2) {
    hashBytes[i / 2] = parseInt(hash.substr(i, 2), 16)
  }
  return btoa(String.fromCharCode(...Array.from(hashBytes)))
}
